/**
* DevExpress Dashboard (_hovered-floating-toolbar.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as $ from 'jquery';
import { FloatingCaptionToolbarBase } from './_floating-toolbar-base';
export class HoveredFloatingCaptionToolbar extends FloatingCaptionToolbarBase {
    constructor(_container, _controlContainer, _popupContainer, encodeHtml, isBottomPosition) {
        super(_container, _controlContainer, _popupContainer, encodeHtml, isBottomPosition);
        this._floatingPanelVisible = false;
    }
    calcMinWidth(options) {
        return 0;
    }
    dispose() {
        if (this._popupContainer) {
            $.fn.constructor(this._popupContainer).off('mouseover.captionPanel');
            $.fn.constructor(this._popupContainer).off('mouseleave.captionPanel');
        }
        super.dispose();
    }
    _appendToContainer(toolbarDiv) {
        var element = super._appendToContainer(toolbarDiv);
        let toggleHoverState = (hovered) => {
            if (this._floatingPanelVisible !== hovered) {
                this._floatingPanelVisible = hovered;
                hovered ? this.showFloatingPanel() : this.hideFloatingPanel();
            }
        };
        $.fn.constructor(this._popupContainer).on('mouseover.captionPanel', () => toggleHoverState(true));
        $.fn.constructor(this._popupContainer).on('mouseleave.captionPanel', () => toggleHoverState(false));
        return element;
    }
    _createInstance() {
        return new HoveredFloatingCaptionToolbar(undefined, undefined, undefined, this.encodeHtml, this._isBottomPosition);
    }
}
